/**
 * The strip's line of who in Support is on duty in Dialpad: "Support available: Carlyrose, Angie",
 * the names in bold (Jeff, 2026-10-23). Other departments are in the rail's Team list. Nothing
 * until the team has arrived.
 */
import { type TeamMember } from '@lsc/contract';
import { presenceLabel } from '@lsc/domain';
import { firstName } from '../../lib/team';

const SHOWN = 4;
const LABEL = 'Support available:';

/** Support on duty, by name; each name with its Dialpad word unless Available; four then +N. */
export function supportOnNow(team: TeamMember[]): { names: string[]; more: number; everyone: string } {
  const on = team.filter((m) => m.onDuty && m.department === 'support').sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
  return {
    names: on.slice(0, SHOWN).map((m) => (m.word === 'available' ? firstName(m.name) : `${firstName(m.name)} (${presenceLabel(m.word).toLowerCase()})`)),
    more: Math.max(0, on.length - SHOWN),
    everyone: on.map((m) => m.name).join(', '),
  };
}

export function onNowText(team: TeamMember[]): string {
  const { names, more } = supportOnNow(team);
  if (names.length === 0) return 'No one in Support is on duty in Dialpad.';
  return `${LABEL} ${names.join(', ')}${more > 0 ? ` +${String(more)}` : ''}`;
}

export function OnNow({ team }: { team: TeamMember[] | null }) {
  if (!team) return null;
  const { names, more, everyone } = supportOnNow(team);
  if (names.length === 0) return <span className="min-w-0 truncate text-attention">No one in Support is on duty in Dialpad.</span>;
  return (
    <span className="min-w-0 truncate text-ink-2" title={everyone} aria-label={onNowText(team)}>
      {LABEL} <span className="font-medium text-ink">{names.join(', ')}</span>
      {more > 0 && <span>{` +${String(more)}`}</span>}
    </span>
  );
}
